<customform [identifier]="component.form_identifier"
            [source]="component.newsletter_source" />